module.exports.ben = {
	name        : 'Ben',
	description : 'Ben',

	ability: (player, world, resolve) => {
		player.mesh.spine.state.setAnimation(0, player.animations.idle, true);

		resolve();
	},

	deactivate: (player, world, resolve) => {
		player.mesh.spine.state.setAnimation(0, player.animations.idle, true);

		resolve();
	},

	transform(player, resolve) {
		player.signals.transformEffect.dispatch();

		player.mesh.spine.state.setAnimation(0, 'transform', false);
		player.mesh.spine.state.tracks[0].listener = {
			event: (t, e) => {
				if (e.stringValue === 'sfx_transformback' || e.stringValue === 'sfx_transform') {
					P3.audio.playSound('sfx_omnitrix_transform_00');
				}
			},
			complete: () => {
				resolve();
			}
		};
	},
	walkspeed          : 1000,
	canFly             : false,
	canJump            : true,
	invincibleToWater  : false,
	invincibleToLava   : false,
	invincibleToAcid   : false,
	invincibleToSpikes : false,
	footstepsLeft      : [
		'sfx_footstep_metal_00', 'sfx_footstep_temple_00', 'sfx_footstep_stone_00'
	],
	foorstepsRight: [
		'sfx_footstep_metal_01', 'sfx_footstep_temple_01', 'sfx_footstep_stone_01'
	],
	animations: {
		idle : 'idle1',
		jump : 'jump',
		run  : 'walk',
		die  : 'die'
	},
	dangerousParticles: [
		'particle_steam_column',
		'particle_steam_horizontal',
		'particle_steam_jet_horizontal',
		'particle_steam_vertical',
		'particle_fire_vertical',
		'particle_fire_pit_vertical',
		'particle_fire_horizontal'
	]
};

module.exports.stinkfly = {
	name        : 'Stinkfly',
	description : 'Stinkfly',
	ability     : (player, world, resolve) => {
		this.flyUp(player, resolve);
		player.mesh.spine.state.setAnimation(0, player.animations.fly, true);
	},
	deactivate: (player, world, resolve) => {
		this.flyDown(player, resolve);
	},
	flyUp: (player, resolve) => {
		new P3.utils.TWEEN.Tween(player.mesh.position, this.tweens)
			.to({
				y: '+2.6'
			}, 1000)
			.easing(P3.utils.TWEEN.Easing.Quartic.In)
			.onComplete(() => {
				return resolve();
			})
			.start();
	},
	flyDown: (player, resolve) => {
		new P3.utils.TWEEN.Tween(player.mesh.position, this.tweens)
			.to({
				y: '-2.6'
			}, 1000)
			.easing(P3.utils.TWEEN.Easing.Quartic.In)
			.onComplete(() => {
				return resolve();
			})
			.start();
	},
	walkspeed          : 1000,
	canFly             : true,
	canJump            : false,
	invincibleToWater  : true,
	invincibleToLava   : true,
	invincibleToAcid   : true,
	invincibleToSpikes : true,
	footstepsLeft      : [
		'sfx_footstep_metal_00', 'sfx_footstep_temple_00', 'sfx_footstep_stone_00'
	],
	foorstepsRight: [
		'sfx_footstep_metal_01', 'sfx_footstep_temple_01', 'sfx_footstep_stone_01'
	],
	animations: {
		idle : 'flying',
		jump : 'flying',
		run  : 'flying',
		die  : 'die_air',
		fly  : 'flying'
	},
	dangerousParticles: [
		'particle_steam_column',
		'particle_steam_vertical',
		'particle_fire_vertical',
		'particle_fire_pit_vertical'
	]
};

module.exports.cannonbolt = {
	name        : 'Cannonbolt',
	description : 'Cannonbolt',
	ability     : (player, world, resolve) => {
		const startAnim = 'transform_back';
		const nextAnim = player.animations.idle;

		player.mesh.spine.state.data.setMix(startAnim, nextAnim, 1);

		player.mesh.spine.state.setAnimation(0, 'transform_back', false);

		player.mesh.spine.state.tracks[0].listener =
        {
        	complete: () => {
        		player.mesh.spine.state.setAnimation(0, nextAnim, true);

        		resolve();
        	}
        };
	},
	deactivate: (player, world, resolve) => {
		resolve();
	},
	walkspeed          : 1000,
	canFly             : false,
	canJump            : true,
	invincibleToWater  : false,
	invincibleToLava   : false,
	invincibleToAcid   : true,
	invincibleToSpikes : false,
	footstepsLeft      : [
		'sfx_footstep_heavy_metal_00', 'sfx_footstep_heavy_metal_00', 'sfx_footstep_heavy_metal_00'
	],
	foorstepsRight: [
		'sfx_footstep_heavy_metal_01', 'sfx_footstep_heavy_metal_01', 'sfx_footstep_heavy_metal_01'
	],
	animations: {
		idle : 'idle',
		jump : 'jump',
		run  : 'walk',
		roll : 'roll',
		die  : 'die'
	},
	dangerousParticles: [
		'particle_steam_column',
		'particle_steam_horizontal',
		'particle_steam_jet_horizontal',
		'particle_steam_vertical',
		'particle_fire_vertical',
		'particle_fire_pit_vertical',
		'particle_fire_horizontal'
	]
};

module.exports.fourarms = {
	name        : 'Four Arms',
	description : 'Four Arms',
	ability     : (player, world, resolve) => {
		const startAnim = 'transform_back';
		const nextAnim = player.animations.idle;

		player.mesh.spine.state.data.setMix(startAnim, nextAnim, 1);
		player.mesh.spine.state.setAnimation(0, 'transform_back', false);
		player.mesh.spine.state.tracks[0].listener =
        {
        	complete: () => {
        		player.mesh.spine.state.setAnimation(0, nextAnim, true);
        		resolve();
        	}
        };
	},
	deactivate: (player, world, resolve) => {
		player.mesh.spine.state.setAnimation(0, player.animations.idle, true);
		resolve();
	},
	walkspeed          : 1000,
	canFly             : false,
	canJump            : true,
	invincibleToWater  : false,
	invincibleToLava   : false,
	invincibleToAcid   : false,
	invincibleToSpikes : false,
	footstepsLeft      : [
		'sfx_footstep_heavy_metal_00', 'sfx_footstep_heavy_temple_00', 'sfx_footstep_heavy_stone_00'
	],
	foorstepsRight: [
		'sfx_footstep_heavy_metal_01', 'sfx_footstep_heavy_temple_01', 'sfx_footstep_heavy_stone_01'
	],
	animations: {
		idle : 'idle',
		jump : 'jump',
		run  : 'walk',
		die  : 'die'
	},
	dangerousParticles: [
		'particle_steam_column',
		'particle_steam_horizontal',
		'particle_steam_jet_horizontal',
		'particle_steam_vertical',
		'particle_fire_vertical',
		'particle_fire_pit_vertical',
		'particle_fire_horizontal'
	]
};

module.exports.heatblast = {
	name        : 'Heatblast',
	description : 'Heatblast',
	ability     : (player, world, resolve) => {
		const startAnim = 'transform_back';
		const nextAnim = player.animations.idle;

		player.mesh.spine.state.data.setMix(startAnim, nextAnim, 1);
		player.mesh.spine.state.setAnimation(0, 'transform_back', false);
		player.mesh.spine.state.tracks[0].listener =
        {
        	complete: () => {
        		player.mesh.spine.state.setAnimation(0, nextAnim, true);
        		resolve();
        	}
        };
	},
	deactivate: (player, world, resolve) => {
		player.mesh.spine.state.setAnimation(0, player.animations.idle, true);
		resolve();
	},
	walkspeed          : 1000,
	canFly             : false,
	canJump            : true,
	invincibleToWater  : false,
	invincibleToLava   : true,
	invincibleToAcid   : false,
	invincibleToSpikes : false,
	footstepsLeft      : [
		'sfx_footstep_metal_00', 'sfx_footstep_temple_00', 'sfx_footstep_stone_00'
	],
	foorstepsRight: [
		'sfx_footstep_metal_01', 'sfx_footstep_temple_01', 'sfx_footstep_stone_01'
	],
	animations: {
		idle : 'idle',
		jump : 'jump',
		run  : 'walk',
		die  : 'die'
	},
	dangerousParticles: [
	]
};

module.exports.overflow = {
	name        : 'Overflow',
	description : 'Overflow',
	ability     : (player, world, resolve) => {
		const startAnim = 'transform_back';
		const nextAnim = player.animations.idle;

		player.mesh.spine.state.data.setMix(startAnim, nextAnim, 1);
		player.mesh.spine.state.setAnimation(0, 'transform_back', false);
		player.mesh.spine.state.tracks[0].listener =
        {
        	complete: () => {
        		player.mesh.spine.state.setAnimation(0, nextAnim, true);
        		resolve();
        	}
        };
	},
	deactivate: (player, world, resolve) => {
		player.mesh.spine.state.setAnimation(0, player.animations.idle, true);
		resolve();
	},
	walkspeed          : 1000,
	canFly             : false,
	canJump            : true,
	invincibleToWater  : true,
	invincibleToLava   : false,
	invincibleToAcid   : false,
	invincibleToSpikes : false,
	footstepsLeft      : [
		'sfx_footstep_heavy_metal_00', 'sfx_footstep_heavy_temple_00', 'sfx_footstep_heavy_stone_00'
	],
	foorstepsRight: [
		'sfx_footstep_heavy_metal_01', 'sfx_footstep_heavy_temple_01', 'sfx_footstep_heavy_stone_01'
	],
	animations: {
		idle : 'idle',
		jump : 'jump',
		run  : 'walk',
		die  : 'die'
	},
	dangerousParticles: [
		'particle_steam_column',
		'particle_steam_horizontal',
		'particle_steam_jet_horizontal',
		'particle_steam_vertical',
		'particle_fire_vertical',
		'particle_fire_pit_vertical',
		'particle_fire_horizontal'
	]
};
